import { useEffect, useRef } from 'react';
import { currentSeason, PASS, PASS_TIERS, rewardIcon, rewardName, XP_PER_TIER } from '@aleaces/engine';
import { buyPremium } from '../actions';
import { useProfile } from '../hooks';
import { passTier } from '../profile';

export function PassScreen() {
  const p = useProfile();
  const t = p ? passTier(p) : 0;
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const cur = track.querySelector<HTMLElement>('.tier-num.current');
    if (cur) track.scrollLeft = Math.max(0, cur.offsetLeft - 300);
  }, []);

  if (!p) return null;

  return (
    <section className="screen">
      <div className="pass-head">
        <div>
          <div className="eyebrow">Saison {currentSeason().num} · Battlepass</div>
          <h1>{currentSeason().name}</h1>
          <p className="muted" style={{ maxWidth: '60ch', margin: '6px 0 0' }}>
            Jede gespielte Hand bringt Erfahrung. Alle {XP_PER_TIER} EP steigt der Pass eine Stufe. Der Gratis-Track ist für alle
            offen, der Premium-Track schaltet zusätzlich Skins, Rahmen und Tische frei – rein kosmetisch, nie Chips.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <div className="pill">
            <span className="ic" style={{ background: 'var(--gold)' }}>{t}</span>
            Stufe {t} / {PASS_TIERS} · {p.passXP % XP_PER_TIER} / {XP_PER_TIER} EP
          </div>
          {p.premium ? (
            <span className="pill" style={{ borderColor: 'var(--gold)' }}>
              <span className="ic" style={{ background: 'var(--gold-hi)' }}>★</span>Premium aktiv
            </span>
          ) : (
            <button className="btn gold" onClick={() => buyPremium()}>Premium freischalten · 950 Taler</button>
          )}
        </div>
      </div>
      <div className="pass-track" ref={trackRef}>
        <div className="pass-rows">
          <div className="track-label">Stufe</div>
          <div className="track-label">Gratis</div>
          <div className="track-label premium">Premium</div>
          {PASS.map((row) => {
            const reached = row.tier <= t;
            return (
              <FragmentRow key={row.tier} tier={row.tier} reached={reached} current={row.tier === t + 1} premiumActive={p.premium}
                freeIcon={rewardIcon(row.free)} freeName={rewardName(row.free)}
                premIcon={rewardIcon(row.premium)} premName={rewardName(row.premium)} />
            );
          })}
        </div>
      </div>
      <p className="muted" style={{ maxWidth: '70ch', margin: '14px auto 0', fontFamily: 'var(--font-ui)', fontSize: 13 }}>
        Hinweis: In dieser Version kostet Premium Taler aus dem Spiel. Zum Launch wird daraus ein einmaliger Kauf pro Saison –
        ohne Einfluss auf die Chips am Tisch, keine Lootboxen.
      </p>
    </section>
  );
}

function FragmentRow({ tier, reached, current, premiumActive, freeIcon, freeName, premIcon, premName }: {
  tier: number; reached: boolean; current: boolean; premiumActive: boolean;
  freeIcon: string; freeName: string; premIcon: string; premName: string;
}) {
  return (
    <>
      <div className={'tier-num' + (reached ? ' reached' : '') + (current ? ' current' : '')}>{tier}</div>
      <div className={'reward ' + (reached ? 'owned' : 'locked')}>
        <div className="ric" style={{ background: 'rgba(255,255,255,.05)' }}>{freeIcon}</div>
        <div className="rname">{freeName}</div>
      </div>
      <div className={'reward premium ' + (reached && premiumActive ? 'owned' : 'locked')}>
        <div className="ric" style={{ background: 'rgba(226,165,58,.15)' }}>{premIcon}</div>
        <div className="rname">{premName}</div>
      </div>
    </>
  );
}
